const setModal = () => {
  const btnTriggers = document.querySelectorAll(".open-modal");
  const modal = document.querySelector("#modal");
  const modalContent = document.querySelector("#modal .modal-content");
  const iframe = document.querySelector("#modal iframe");
  const btnClose = document.querySelector("#modal .btn-close-modal");
  const html = document.querySelector("html");
  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  let activeTrigger = null;

  if (
    !btnTriggers.length ||
    !modal ||
    !modalContent ||
    !iframe ||
    !btnClose ||
    !html
  ) {
    return;
  }

  const getVideoUrl = (video) => {
    try {
      const url = new URL(video);
      const allowedHosts = new Set([
        "player.vimeo.com",
        "youtube.com",
        "www.youtube.com",
        "www.youtube-nocookie.com",
      ]);

      if (url.protocol !== "https:" || !allowedHosts.has(url.hostname)) {
        return "";
      }

      url.searchParams.set("autoplay", "1");
      url.searchParams.set("rel", "0");
      return url.toString();
    } catch {
      return "";
    }
  };

  const finishClose = () => {
    modal.style.display = "none";
    modal.style.position = "";
    modal.style.top = "";
    modal.style.left = "";
    modal.setAttribute("aria-hidden", "true");
    modal.setAttribute("inert", "");
    iframe.src = "";
    html.style.overflow = "";

    if (activeTrigger) {
      activeTrigger.focus();
      activeTrigger = null;
    }
  };

  const openModal = (button) => {
    if (!button.dataset.video) {
      return;
    }

    let videoUrl;
    if (window.innerWidth < 991 && button.dataset.videoMobile) {
      videoUrl = button.dataset.videoMobile;
    } else {
      videoUrl = button.dataset.video;
    }

    const embedUrl = getVideoUrl(videoUrl);
    if (!embedUrl) {
      return;
    }

    activeTrigger = button;
    iframe.src = embedUrl;
    modal.removeAttribute("inert");
    modal.setAttribute("aria-hidden", "false");
    modal.style.position = "fixed";
    modal.style.top = "0";
    modal.style.left = "0";
    modal.style.display = "flex";
    html.style.overflow = "hidden";
    modalContent.classList.remove("fade-out");
    if (!reducedMotion.matches) {
      modalContent.classList.add("fade-in");
    }
    btnClose.focus();
  };

  const closeModal = () => {
    if (modal.getAttribute("aria-hidden") === "true") {
      return;
    }

    modalContent.classList.remove("fade-in");
    modal.setAttribute("aria-hidden", "true");

    if (reducedMotion.matches) {
      finishClose();
      return;
    }

    modalContent.classList.add("fade-out");
    modalContent.addEventListener(
      "animationend",
      () => {
        if (modalContent.classList.contains("fade-out")) {
          modalContent.classList.remove("fade-out");
          finishClose();
        }
      },
      { once: true },
    );
  };

  btnTriggers.forEach((button) => {
    button.addEventListener("click", () => openModal(button));
  });

  btnClose.addEventListener("click", closeModal);
  modal.addEventListener("click", (event) => {
    if (!modalContent.contains(event.target)) {
      closeModal();
    }
  });
  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      closeModal();
    }
  });
};

export default setModal;
